import { pathBuilder } from 'config/paths/index';
import { root as featureRoot } from 'config/paths/digitalForms';

export const root = `${featureRoot}/templates`;
export default pathBuilder(root);
